export class WorkloadCaseEntity {
  public caseId!: string;
  public caseNumber!: string;
  public caseTypeName!: string;
  public overdueText!: string;
  public overdueDays!: number;
  public status!: string;
  public detailUrl!: string;

  public caseTypeId?: string;
  public statusId?: string;
  public statusName?: string;
  public priorityCode?: string;
  public dueDate?: string | null;
  public isOverdue?: boolean;
  public isAtRisk?: boolean;
  public isClosed?: boolean;
}
